export default __webpack_public_path__ + "static/media/TPResume.82daf002.pdf";